import { useEffect, useRef, useState } from 'react';

export function useHealthCheck(): boolean {
  const [isHealthy, setIsHealthy] = useState(true);
  const intervalRef = useRef<NodeJS.Timeout | null>(null);

  const checkHealth = async () => {
    try {
      const response = await fetch(`/api/health`);
      setIsHealthy(response.status == 200);
    } catch (error) {
      setIsHealthy(false);
    }
  };

  useEffect(() => {
    let cancelled = false;

    const poll = async () => {
      await checkHealth();
      if (!cancelled) {
        intervalRef.current = setTimeout(poll, 2000);
      }
    };

    poll();

    return () => {
      cancelled = true;
      if (intervalRef.current) clearTimeout(intervalRef.current);
    };
  }, []);

  return isHealthy;
}
